import React from "react";
import { Container, Tab } from "semantic-ui-react";
import DocumentUsageOverview from "./DocumentUsageOverview";
import CustomReportGenerator from "./CustomReportGenerator";

const LibraryUsageReport = () => {
  const OverviewTabPane = () => (
    <Tab.Pane>
      <DocumentUsageOverview />
    </Tab.Pane>
  );

  const CustomReportTabPane = () => (
    <Tab.Pane>
      <CustomReportGenerator />
    </Tab.Pane>
  );

  const panes = [
    {
      menuItem: { key: "overview", icon: "dashboard", content: "Overview" },
      render: OverviewTabPane,
    },
    {
      menuItem: {
        key: "custom",
        icon: "file alternate",
        content: "Custom Report",
      },
      render: CustomReportTabPane,
    },
  ];

  return (
    <Container fluid style={{ padding: "0" }}>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </Container>
  );
};

export default LibraryUsageReport;
